export default "__VITE_ASSET__CsIt$GYs__"